import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useState, useCallback } from 'react';
export const AgentsSidePanelContext = /*#__PURE__*/ createContext(undefined);
export const useAgentsSidePanel = ()=>{
    const context = useContext(AgentsSidePanelContext);
    if (!context) {
        throw new Error('useAgentsSidePanel must be used within an AgentsSidePanelProvider');
    }
    return context;
};
export const AgentsSidePanelProvider = ({ children })=>{
    const [isVisible, setIsVisible] = useState(false);
    const [taskAgentId, setTaskAgentId] = useState(undefined);
    const [chatId, setChatId] = useState(undefined);
    const showAgentsSidePanel = useCallback((id, chId)=>{
        setTaskAgentId(id);
        setChatId(chId);
        setIsVisible(true);
    }, []);
    const hideAgentsSidePanel = useCallback(()=>{
        setIsVisible(false);
        setTaskAgentId(undefined);
        setChatId(undefined);
    }, []);
    const value = useMemo(()=>{
        return {
            isVisible,
            taskAgentId,
            chatId,
            showAgentsSidePanel,
            hideAgentsSidePanel,
            setChatId
        };
    }, [
        isVisible,
        taskAgentId,
        chatId,
        showAgentsSidePanel,
        hideAgentsSidePanel
    ]);
    return /*#__PURE__*/ _jsx(AgentsSidePanelContext.Provider, {
        value: value,
        children: children
    });
};
